import { render, staticRenderFns } from "./CreatorsFilters.vue?vue&type=template&id=563b7608&scoped=true&"
import script from "./CreatorsFilters.vue?vue&type=script&lang=ts&"
export * from "./CreatorsFilters.vue?vue&type=script&lang=ts&"
import style0 from "./CreatorsFilters.vue?vue&type=style&index=0&id=563b7608&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563b7608",
  null
  
)

export default component.exports